import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

export const logo = `${process.env.PUBLIC_URL}/logo.png`;

export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'MrBeast', icon: <PsychologyOutlinedIcon /> },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Education', icon: <SchoolIcon />, },
  { name: 'Gaming', icon: <SportsEsportsIcon />, },
  { name: 'Live', icon: <LiveTvIcon />, },
  { name: 'Sport', icon: <FitnessCenterIcon />, },
  { name: 'Fashion', icon: <CheckroomIcon />, },
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Comedy', icon: <TheaterComedyIcon />, },
  { name: 'Gym', icon: <FitnessCenterIcon />, },
];

export const demoThumbnailUrl = 'https://i.ytimg.com/vi/1WEAJ-DFkHE/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAfHIKkwhDbz3Ym11geyybpgjv3AA';
export const demoChannelUrl = '/@MrBeast';
export const demoVideoUrl = '/@MrBeast/videos';
export const demoChannelTitle = 'MrBeast';
export const demoVideoTitle = '$1 vs $500,000 Plane Ticket!';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png';
